import { all, select, takeEvery, fork, call, put } from 'redux-saga/effects'

// action
import { inquiryMgmtActions } from '@redux/store/index'

// api
import { inquiryApi, ResType } from '@api'

// lib
import { Logger } from '@utils'

import { Inquiry, InquiryType } from '@schemas'

const apiGetInquirys = async (): Promise<ResType | undefined> => {
	const res: ResType | undefined = await inquiryApi.getInquiry()
	return res
}

function* triggerInitInquiryMgmt() {
	try {
		yield put(inquiryMgmtActions.INQUIRY_LIST_STATUS('loading'))
		const apiRes: ResType = yield call(apiGetInquirys)

		if (apiRes.status === 200) {
			const tempList = apiRes.data[0] !== undefined ? (apiRes.data as any[]) : []
			const newList = tempList.map(anItem => new Inquiry(anItem as InquiryType))

			yield put(inquiryMgmtActions.INQUIRY_LIST(newList))

			if (newList.length > 0) {
				yield put(inquiryMgmtActions.INQUIRY_LIST_STATUS('ok'))
			} else {
				yield put(inquiryMgmtActions.INQUIRY_LIST_STATUS('empty'))
			}
		} else {
			yield put(inquiryMgmtActions.INQUIRY_LIST_STATUS('empty'))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(inquiryMgmtActions.TRIGGER_INIT_INQUIRY_MGMT, triggerInitInquiryMgmt)
	// yield takeEvery(inquiryMgmtActions.INQUIRY_LIST, inquiryList)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
